import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { IconAction } from '@nimmsta/ng-commons-lib/data-table';
import {
  WorkflowStatus,
  WorkflowTemplate,
} from '@nimmsta/ng-commons-lib/models';

_('workflow.activate');
_('workflow.deactivate');

export class ActivateDeactivateAction extends IconAction<WorkflowTemplate> {
  override getText(item: WorkflowTemplate): string {
    if (item.status === WorkflowStatus.ACTIVE) {
      return 'workflow.deactivate';
    } else {
      return 'workflow.activate';
    }
  }
}
